module.exports = __webpack_public_path__ + "img/icon_Financing.3c5e893b.svg";